"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddActorActionHandler = exports.AddActorActionArgs = void 0;
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
class AddActorActionArgs {
    constructor(actor) {
        this.actor = actor;
        this.__type = ActionType_1.ActionType.AddActor;
        this.__typeName = "AddActor";
    }
}
exports.AddActorActionArgs = AddActorActionArgs;
let AddActorActionHandler = class AddActorActionHandler {
    activate(sequence, container, action) {
        container.addActor(sequence, action.args.actor);
    }
};
AddActorActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.AddActor)
], AddActorActionHandler);
exports.AddActorActionHandler = AddActorActionHandler;
